import Modal from "../../../components/modal";
import React from "react";
import { Controller, useForm } from "react-hook-form";
import { Input, Textarea } from "../../../components/form-inputs/inputs";
import { ErrorLabel } from "../../../components/form-inputs/shared/error-label";

export const CreateSlaModal = ({ open, onClose, onCreateNewCustomSla }) => {
    const { reset, control, handleSubmit } = useForm({
        defaultValues: {
            shortName: "",
            description: "",
        },
    });

    const onSubmitNewSla = (values) => {
        reset();
        onClose();
        onCreateNewCustomSla(values);
    };

    return (
        <Modal
            cssClass="advanced-filters-modal"
            show={open}
            onClose={onClose}
        >
            <div className="flex-column p-16">
                <h2>Create New SLA Group</h2>
                <form onSubmit={handleSubmit(onSubmitNewSla)}>
                    <div className="flex-column form-field">
                        <div className="flex-column form-field">
                            <div className="flex-1 m-b-4">
                                SLA Group Name:<span className="asterix">*</span>
                            </div>
                            <Controller
                                name="shortName"
                                control={control}
                                rules={{
                                    required: "Please enter Group name.",
                                    maxLength: { value: 50, message: "Group name cannot exceed 50 characters." },
                                }}
                                render={({ field, fieldState }) => (
                                    <ErrorLabel errorMessage={fieldState.error?.message}>
                                        <Input
                                            {...field}
                                            onChange={(e) => field.onChange(e.target.value.trim())}
                                            invalid={!!fieldState.error}
                                            className="flex-2"
                                        />
                                    </ErrorLabel>
                                )}
                            />
                        </div>
                        <div className="flex-1 m-b-4">Description:</div>
                        <Controller
                            name="description"
                            control={control}
                            render={({ field }) => (
                                <Textarea
                                    {...field}
                                    rows={4}
                                    className="flex-2"
                                />
                            )}
                        />
                    </div>
                    <div className="border-top button-group -right m-t-16 p-l-12">
                        <button
                            type="button"
                            className="button"
                            onClick={onClose}
                        >
                            Cancel
                        </button>
                        <button
                            type="submit"
                            className="button -primary"
                        >
                            Save
                        </button>
                    </div>
                </form>
            </div>
        </Modal>
    );
};
